function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#202124",
  d: "M10.895 22.288C4.878 22.288 0 17.41 0 11.393 0 5.376 4.878.498 10.895.498c6.017 0 10.894 4.878 10.894 10.895-.004 6.015-4.88 10.89-10.894 10.895z",
  transform: "translate(-763 -546) translate(763 546) translate(1 1)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#202124",
  d: "M11.166.498c-.496 0-.991.037-1.482.11 5.257.739 9.174 5.344 9.174 10.785S14.941 21.44 9.684 22.178c.49.074.986.11 1.482.11 5.867 0 10.623-4.878 10.623-10.895C21.79 5.376 17.033.498 11.166.498z",
  transform: "translate(-763 -546) translate(763 546) translate(1 1)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M10.895 2.563c4.875.004 8.826 3.955 8.83 8.83 0 4.877-3.954 8.83-8.83 8.83-4.877 0-8.83-3.953-8.83-8.83 0-4.876 3.953-8.83 8.83-8.83z",
  transform: "translate(-763 -546) translate(763 546) translate(1 1)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M10.895 2.92c-4.68 0-8.474 3.793-8.474 8.473 0 4.68 3.794 8.474 8.474 8.474s8.473-3.794 8.473-8.474c-.003-4.678-3.795-8.47-8.473-8.473z",
  transform: "translate(-763 -546) translate(763 546) translate(1 1)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#202124",
  d: "M.686 9.675c-.315-.292-.43-.74-.294-1.147.137-.407.5-.696.926-.738.242-.008.479.074.665.229.375.315.85.488 1.34.49.872 0 1.384-.49 1.384-1.645V1.416c0-.601.487-1.09 1.089-1.09s1.09.489 1.09 1.09V6.93c.057.978-.285 1.937-.948 2.658-.71.654-1.65.999-2.615.96-.952.013-1.88-.294-2.637-.872z",
  transform: "translate(-763 -546) translate(763 546) translate(1 1) translate(6.537 5.69)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M5.807.36c.602 0 1.09.487 1.09 1.089v5.513c.056.978-.286 1.937-.948 2.658-.718.645-1.663.978-2.626.926-.96.019-1.896-.288-2.658-.871-.316-.292-.43-.74-.294-1.147.136-.407.498-.696.926-.738.242-.008.478.074.664.229.381.32.864.494 1.362.49.872 0 1.384-.49 1.384-1.645V1.416c0-.601.487-1.09 1.089-1.09l.01.034zM5.796 0c-.376.009-.732.166-.992.438s-.4.635-.392 1.011v5.447c0 1.144-.599 1.275-1.09 1.275-.4-.026-.781-.178-1.089-.436-.24-.194-.54-.298-.85-.294-.366-.006-.72.137-.98.395s-.406.611-.403.978c.006.43.211.832.556 1.09.793.612 1.764.952 2.767.969 1.05.049 2.076-.32 2.854-1.024.747-.77 1.142-1.816 1.09-2.887V1.449c0-.38-.152-.743-.423-1.01C6.574.174 6.208.028 5.83.034L5.796 0z",
  transform: "translate(-763 -546) translate(763 546) translate(1 1) translate(6.537 5.69)"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "#E4EAF7",
  d: "M12.332 3.5c-.406 0-.81.03-1.212.09 4.299.6 7.503 4.34 7.503 8.76s-3.204 8.16-7.503 8.76c.401.06.806.09 1.212.09 4.798 0 8.688-3.962 8.688-8.85 0-2.576-1.08-4.896-2.806-6.513C16.667 4.386 14.601 3.5 12.332 3.5z",
  transform: "translate(-763 -546) translate(763 546)"
}))));

var SvgIconProductJeton = function SvgIconProductJeton(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconProductJeton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-product-jeton.1be68a34.svg";
export { ForwardRef as ReactComponent };